import styles from './RequestsPerModeSection.module.scss';
import { ProgressBar } from 'src/components/FlatAppearance/components/ThreadCombinedCard/components/ProgressBar';
import {
  GraduationCap,
  Lightning,
  Speedometer,
  Infinity,
} from '@phosphor-icons/react';
import { SVG_SIZE_S } from 'src/constants';

type RequestsPerModeSectionProps = {
  standard: number;
  complex: number;
  fast: number;
  total: number;
};

export const RequestsPerModeSection = ({
  standard,
  complex,
  fast,
  total,
}: RequestsPerModeSectionProps) => {
  const getPercentage = (value: number) =>
    total > 0 ? Math.min(100, Math.round((value / total) * 100)) : 0;

  const items = [
    {
      label: 'Standard',
      value: standard,
      pct: getPercentage(standard) || 100,
      class: styles.standard,
      Icon: Speedometer,
    },
    {
      label: 'Complex',
      value: complex,
      pct: getPercentage(complex),
      class: styles.complex,
      Icon: GraduationCap,
    },
    {
      label: 'Fast',
      value: fast,
      pct: getPercentage(fast),
      class: styles.fast,
      Icon: Lightning,
    },
  ];

  if (total === 0) {
    return <ProgressBar count={3} />;
  }

  return (
    <div className={styles.root}>
      {items.map((item) => {
        const { Icon } = item;
        return (
          <div key={item.label} className={styles.row}>
            <Icon size={SVG_SIZE_S} />

            <div className={styles.barBackground}>
              <div
                className={`${styles.barFill} ${item.class}`}
                style={{ width: `${item.pct}%` }}
              />
            </div>

            <div className={styles.label}>
              <b>
                {item.value === -1 ? (
                  <Infinity size={SVG_SIZE_S} weight="bold" />
                ) : (
                  item.value
                )}
              </b>{' '}
              {item.label}
            </div>
          </div>
        );
      })}
    </div>
  );
};
